import { render, staticRenderFns } from "./inbox-document.vue?vue&type=template&id=79878f01"
import script from "./inbox-document.ts?vue&type=script&lang=js&external"
export * from "./inbox-document.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports